import React from 'react';

const T1DSquare: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      fill="currentColor"
      d="M56.577 46.977c.456-.171.868-.44 1.21-.787a3.69 3.69 0 00.786-1.203c.194-.492.29-1.017.283-1.546v-.037a4.168 4.168 0 00-.283-1.548 3.673 3.673 0 00-.787-1.22 3.47 3.47 0 00-1.21-.787 4.223 4.223 0 00-1.572-.283h-2.16v7.686h2.166a4.312 4.312 0 001.573-.274"
    ></path>
    <path
      fill="currentColor"
      d="M50.038 37.035h4.972a7.551 7.551 0 012.745.482 6.484 6.484 0 012.148 1.34 5.945 5.945 0 011.393 2.011c.333.793.5 1.645.492 2.504v.036a6.395 6.395 0 01-.492 2.514 5.954 5.954 0 01-1.393 2.021 6.596 6.596 0 01-2.148 1.348 7.395 7.395 0 01-2.742.492h-4.975V37.035zm-3.204 12.747h-2.768v-9.996l-2.221.547-.583-2.294 3.66-1.094h1.91l.002 12.837zM40.207 39.62h-3.88v10.16h-2.808V39.62h-3.874v-2.584h10.558l.004 2.584zm29.598 11.986V29.872H21.97v22.225L8 59.085l23.825-1.65-.099-.07h22.772v-5.758h15.307z"
    ></path>
    <path
      fill="currentColor"
      d="M76.704 62.348a1.184 1.184 0 11.836-.35 1.184 1.184 0 01-.837.347v.003zm-6.188-.35a1.184 1.184 0 11-1.674-1.674 1.184 1.184 0 011.674 1.675zm-7.862.347a1.185 1.185 0 110-2.37 1.185 1.185 0 010 2.37zM91 70.043l-7.75-3.873V53.85H56.736v15.24h21.115l-.053.04L91 70.043z"
    ></path>
  </svg>
);

export default T1DSquare;
